<div class="full-wraper">
  <main role="main" class="maincnt mainmrg">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <p class="text-center font16 text-muted plsmsg mt-5">
            Please wait for a few seconds...
          </p>
          <div class="text-center mt-3 mb-4">
            <img src="assets/images/loading-old.gif" />
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
